import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconColorFan20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconColorFan20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 15v2a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5m0-2.12L5.664 7.4H5.5V4a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5zM7 5.086l.788-1.365a2 2 0 0 1 2.733-.733l2.231 1.289a2 2 0 0 1 .732 2.732l-.206.356.367-.211a2 2 0 0 1 2.732.732l1.288 2.232a2 2 0 0 1-.732 2.732l-.26.15H17a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3q-.1 0-.2-.01A2 2 0 0 1 1 17V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm9.183 6.465L13.673 13H6.519l7.876-4.547a.5.5 0 0 1 .683.183l1.288 2.232a.5.5 0 0 1-.183.683M10.68 8.865l-6.195 3.577 4.602-7.971a.5.5 0 0 1 .683-.184l2.232 1.289a.5.5 0 0 1 .183.683z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconColorFan20);
